import * as actions from '../actions';
function createContext(state, events) {
    const ctx = Object.assign(Object.assign({}, events), { apis: {}, converters: {
            html: ({ component }) => component,
        }, state });
    return ctx;
}
export function includeActions(ctx, actions) {
    const actionNames = Object.keys(actions);
    for (const actionName of actionNames) {
        const action = actions[actionName];
        ctx[actionName] = action.bind(ctx, ctx);
    }
}
export function createActions(state, events) {
    const context = createContext(state, events);
    includeActions(context, actions);
    return context;
}
//# sourceMappingURL=createActions.js.map